import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getArticleList } from "@/content/articles";

export default function ArticleSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language ?? "en").split("-")[0];
  const articles = getArticleList(lang);

  return (
    <section id="guides" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-book-open-line"></i>
              {t("article.title")}
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t("article.subtitle")}
            </h2>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 cursor-pointer transition-colors"
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="line-clamp-2 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {article.description}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
                  {t("article.readMore")}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}